import React, { useState } from "react";
import Box from "components/Box";
import AccordeonButton from "../AccordeonButton";
import { useCollapse } from "react-collapsed";
import Heading from "@hubins/components/Heading";

const ExpandableContent = ({
  children,
  label,
  className,
}: {
  children: React.ReactNode;
  label: string | React.ReactNode;
  className?: string;
}) => {
  const [isExpanded, setExpanded] = useState(false);
  const handleClick = () => {
    setExpanded(!isExpanded);
  };
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

  return (
    <Box className={`border ${className}`}>
      <AccordeonButton {...{ ...getToggleProps({ onClick: handleClick }), ref: undefined }}>
        <Heading element="span" size="5" className="">
          {label}
        </Heading>
      </AccordeonButton>
      <div {...getCollapseProps()}>{children}</div>
    </Box>
  );
};

export default ExpandableContent;
